import {
    TransferEndpoint as TransferEndpointModel,
    SearchTransferRequest,
    SearchTransferResponse,
} from './transfer.interfaces';
import { delay } from '@shared/utils/async';
import { HttpEndpoint } from '@/api/httpEndpoints';
import { fakeTransferData } from '@/api/Transfer/transfer.fake';

const endpointPath = '/mvc/TransfersApi/SearchTransfers';
const runTestApi = false; // Toggle this to combine local fakeData with Monolith api calls

export class TransferEndpoint extends HttpEndpoint implements TransferEndpointModel {
    public constructor(applicationUrl: string) {
        super(applicationUrl);
    }

    public async Search(request: SearchTransferRequest): Promise<SearchTransferResponse> {
        return await this.post<SearchTransferResponse>(endpointPath, request);
    }
}

export class FakeTransferEndpoint extends HttpEndpoint implements TransferEndpointModel {
    public async Search(request: SearchTransferRequest): Promise<SearchTransferResponse> {
        if (runTestApi) {
            const response = await this.post<SearchTransferResponse>(endpointPath, {
                ...request,
                fakeData: true,
            });
            return response;
        }

        await delay(1000);

        return fakeTransferData;
    }
}
